import moment from 'moment'

export const JSON_FIELDS_CSV = {
    scanLocalHistory: {
        pt: {
            json_fields: {
                Empresa: 'account',
                Cliente: 'client',
                Local: 'site',
                Ponto: 'point',
                Data: 'date',
                Leituras: 'scans',
            },
            json_data: [
                {
                    account: '',
                    client: '',
                    site: '',
                    point: '',
                    date: '',
                    scans: '',
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            pdfTitle: 'RELATÓRIO DE FREQUÊNCIA',
            title: 'RELATÓRIO DE FREQUÉNCIA - ' + 'Relatório gerado em: ' + moment().format('DD/MM/YYYY') + ' às ' + moment().format('HH:mm:ss'),
            filename: 'scan_local_history_' + moment().format('YYYY-MM-DD'),
        },
        en: {
            json_fields: {
                Account: 'account',
                Client: 'client',
                Site: 'site',
                Point: 'point',
                Date: 'date',
                Scans: 'scans',
            },
            json_data: [
                {
                    account: '',
                    client: '',
                    site: '',
                    point: '',
                    date: '',
                    scans: '',
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            pdfTitle: 'FREQUENCY SCAN REPORT',
            title: 'FREQUENCY SCAN REPORT - ' + 'Report generated on: ' + moment().format('MM/DD/YYYY') + ' at ' + moment().format('HH:mm:ss'),
            filename: 'scan_local_history_' + moment().format('YYYY-MM-DD'),
        },
    },
}
